class SharedStorageInitValue {
    constructor() {
        this.initValue = {
            // allowing updates on individual nested storage keys isn't worth it yet, see the redux reducer generator
            // so everything is flat for now

            whitelabel: {
                name: "iCompaas",
                copyright_name: "iCompaas LLC",
                safe_name: "iCompaas", // Name without spaces, periods, or extended characters but not lowercased. Used in file names for example
                // logo_url: "",
                customer_support_contact: {
                    email: "customersuccess@icompaas.com"
                },
            },

            assessment_exception_type: "contemporary", // "contemporary" || "as_of_assessment"

            auth_is_signed_in: false,
            auth_primary_role: null,

            cac_in_focus_cloud_account_id: null,
            cac_in_focus_cloud_type: null,
            cac_in_focus_cloud_display_name: "",

            cloud_assessment_complete_compliance_code_list: ["cislevel1", "cislevel2", "hipaa", "soc2", "iso27001", "security"],            

            route_cloud_account_setup: "/unset",
        }
    }

    getInitValue = () => {
        return this.initValue;
    }
}

export default SharedStorageInitValue;